module.exports = __webpack_public_path__ + "media/five_columns.9542bacb.wav";